import React, { Component } from "react";
import {
    Container,
    Box,
    Typography
} from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import Footer from '../core/Footer';
import EventCalendar from './EventCalendar';

class AllEvents extends Component {
    resourceList = [
        {
            fieldName: 'general',
            title: 'General Sessions'
        },
        {
            fieldName: 'business',
            title: 'Business Strategy Committee'
        },
        {
            fieldName: 'civil',
            title: 'Civil Committee'
        },
        {
            fieldName: 'electrical',
            title: 'Electrical Committee'
        },
        {
            fieldName: 'physical',
            title: 'Physical Committee'
        },
        {
            fieldName: 'technology',
            title: 'Technology Committee'
        },
        {
            fieldName: 'innovation',
            title: 'Innovation Committee'
        }
    ];

    render() {
        return (
            <>
                <Container maxWidth="xl">
                    {/* Header Section */}
                    <Box sx={{ my: 4 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                            <EventIcon sx={{ fontSize: 40, color: 'primary.main' }} />
                            <Typography variant="h3" component="h1" sx={{ fontWeight: 600 }}>
                                All SDSIC Events
                            </Typography>
                        </Box>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                            View all upcoming committee meetings, events, and sessions across all SDSIC committees.
                        </Typography>
                    </Box>

                    {/* Calendar Component */}
                    <EventCalendar
                        isAdmin={false}
                        weekView={false}
                        resourceList={this.resourceList}
                        calendarHeight={800}
                        startTime={8}
                        endTime={18}
                    />
                </Container>

                <Footer />
            </>
        )
    }
};

export default AllEvents;